import { createApp } from 'vue'
import VConsole from 'vconsole'
import App from './App.vue'
import './style.css'
import './assets/styles/global.css'
import { setupI18n } from './locale'
import { setupStore } from './store'
import { setupRouter } from './router'
import Toast from './components/Toast'
import { darkTheme } from 'naive-ui'
// import './utils/copy'

if (import.meta.env.VITE_APP_COMPILE !== 'prod') {
  new VConsole()
}

async function bootstrap() {
  const app = createApp(App)

  app.provide<typeof Toast>('toast', Toast)

  app.provide('configProvider', {
    theme: darkTheme,
    rtl: true, // 启用 RTL
  })

  setupI18n(app)

  setupStore(app)

  await setupRouter(app)

  app.mount('#app')
}

bootstrap()
